export default function(_) {
  for (var x, k, i=1, len=arguments.length; i<len; ++i) {
    x = arguments[i];
    for (k in x) { _[k] = x[k]; }
  }
  return _;
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/extend.js
// module id = 1534
// module chunks = 0